import styled from 'styled-components'

export const Dados = styled.div`
  margin-top: 25px;
`

export const ContainerLink = styled.div`
  margin-bottom: 28px;
`

export const TituloPagina = styled.h1`
  width: 100%;
  margin: 8px 0 0;
  text-align: center;
  font-size: 42px;
  font-weight: 400;
`
